module.exports = __webpack_public_path__ + "img/consult.aea95247.png";